import accountApi from '@account/api'
import { debounce } from './debounce'
import { invalidateUrl } from '@appbase/util'
interface CacheData<TValue> {
  [key: string]: TValue
}

interface ICacheManager<TValue> {
  data: CacheData<TValue>
  get: (key: string) => Promise<TValue>
  set: (key: string, value: TValue) => void
}

abstract class CacheManagerBase<TValue> implements ICacheManager<TValue> {
  constructor() {
    this.debounceFunction = debounce(this.set)
  }

  data: CacheData<TValue> = Object.create(null)

  abstract get(key: string): Promise<TValue>

  set(key: string, value: TValue) {
    this.data[key] = value
  }

  debounceFunction!: (key: string, value: TValue) => void
}

class AvatarCacheManager extends CacheManagerBase<string> {
  [x: string]: any
  constructor() {
    super()
  }

  get(email: string) {
    var avatar = this.data[email]
    if (avatar) {
      return Promise.resolve(avatar)
    } else {
      if (process.env.NODE_ENV === 'development') {
        return Promise.resolve('')
      } else {
        if (email && email?.indexOf('=') == -1) {
          return accountApi.account.getPhotoUrl(email).then((url) => {
            if (!url) {
              url = '/cm/gres/faux/images/ghost.png'
            } else {
              url = invalidateUrl(url)
            }
            this.set(email, url)
            return url
          })
        } else {
          let url = '/cm/gres/faux/images/ghost.png'
          this.set(email, url)
          return Promise.resolve(url)
        }
      }
    }
  }

  // getByCodes(codes: string[]): Promise<account.EmployeePhoto[]> {
  //   return accountApi.account.getPhotoUrlByCodes(codes).then((res) => {
  //     res.forEach((p) => this.set(p.personCode, p.photoPath))
  //     return res
  //   })
  // }
}

// class HrCacheManager extends CacheManagerBase<account.User> {
//   constructor() {
//     super()
//   }

//   get(email: string) {
//     var user = this.data[email]
//     if (user) {
//       return Promise.resolve(user)
//     } else {
//       return accountApi.account.getUser(email).then((user) => {
//         console.log('user', user)
//         this.set(email, user)
//         return user
//       })
//     }
//   }
// }

export type Cache = {
  avatar: AvatarCacheManager
  //hr: HrCacheManager
}

export const cache: Cache = {
  avatar: new AvatarCacheManager(),
  //hr: new HrCacheManager(),
}
